import { Client } from "./_clientService";

async function getWeeklyLeaderboardConfig() {
    try {
        let path = "/weekly-leaderboard/config";
        const resp = await new Client({ path }).post();

        return resp;
    } catch (error) {
        throw error;
    }
}

async function updateWeeklyLeaderboardConfig(config: any) {
    try {
        const resp = await new Client({
            path: "/weekly-leaderboard/config/update",
            payload: { ...config },
        }).post();
        return resp;
    } catch (error) {
        throw error;
    }
}

async function getLeagueTypes() {
    try {
        const resp = await new Client({
            path: "/weekly-leaderboard/types",
        }).post();
        return resp;
    } catch (error) {
        throw error;
    }
}

async function getAllPools({ limit = 100, leagueType, page = 1, poolId = null, userId = null }) {
    try {
        const resp = await new Client({
            path: "/weekly-leaderboard/all",
            payload: { limit, leagueType, page, poolId, userId },
        }).post();
        return resp;
    } catch (error) {
        throw error;
    }
}

async function startWeeklyLeaderboards() {
    try {
        const resp = await new Client({
            path: "/weekly-leaderboard/start",
        }).post();
        return resp;
    } catch (error) {
        throw error;
    }
}

async function finalizeWeeklyLeaderboards() {
    try {
        const resp = await new Client({
            path: "/weekly-leaderboard/finalize",
        }).post();
        return resp;
    } catch (error) {
        throw error;
    }
}

export {
    getWeeklyLeaderboardConfig,
    updateWeeklyLeaderboardConfig,
    getLeagueTypes,
    getAllPools,
    startWeeklyLeaderboards,
    finalizeWeeklyLeaderboards,
};